'use client';

import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';
import { MultiSelectDropdown } from '../../../OffersFilter/MultiSelectDropdown';
import { useFilterEvents } from '../../../OffersFilter/useFilterEvents';
import { useRangeFilterOptions } from '../store/hooks';
import { useOffersFilterStore } from '../store/useOffersFilterStore';

export const MinDepositSelect = ({
  isStickyBar = false,
  scrollBackToMainBar,
  actionSection,
  pageIdentifier,
}: {
  isStickyBar?: boolean;
  scrollBackToMainBar?: () => void;
  actionSection: string;
  pageIdentifier: string;
}) => {
  const options = useRangeFilterOptions('minimumBalance');
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    ({ handleUpdateFilterFormState, handleApplyFilters, appliedFilters }) => ({
      handleUpdateFilterFormState,
      handleApplyFilters,
      appliedFilters,
    }),
    shallow,
  );
  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });

  const handleChange = useCallback(
    (selectedLabels: string[]) => {
      if (scrollBackToMainBar) scrollBackToMainBar();
      setTimeout(
        () => {
          handleUpdateFilterFormState({ selectedMinDepositRanges: selectedLabels });
          const newState = handleApplyFilters();
          if (!newState) return;
          updateFiltersEvent({
            additional_attributes: {
              min_deposit: selectedLabels,
              term_length: newState.appliedFilters.selectedTermRanges,
            },
          });
        },
        scrollBackToMainBar ? 100 : 0,
      );
    },
    [handleUpdateFilterFormState, handleApplyFilters, updateFiltersEvent, scrollBackToMainBar],
  );

  return (
    <MultiSelectDropdown
      isStickyBar={isStickyBar}
      label="Minimum Deposit"
      options={options}
      selectedOptions={appliedFilters?.selectedMinDepositRanges || []}
      onChange={handleChange}
      useStore={useOffersFilterStore}
    />
  );
};
